import { isObject } from './object';
export function isAxiosError(payload) {
  return isObject(payload) && payload.isAxiosError === true;
}
export function isAxiosErrorWithResponse(error) {
  return isAxiosError(error) && error.response !== undefined;
}